// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"quote-module--wrapper--1y9ac","quote":"quote-module--quote--3RKdC","author":"quote-module--author--3HOzf"};